/* Free course lead capture.
   The free course is delivered by email. This module:
   1. injects a signup band just above the footer on every page (id="free-course"),
   2. opens a popup email form from any <a href="#free-course"> trigger, and
      on a timer, unless turned off,
   3. posts the email straight to a Brevo signup form (no Shopify customer,
      no captcha) — the Brevo automation on that list sends the course email.
   All copy, switches, timings and the Brevo form link come from the
   "Free course signup" section (sections/free-course-signup.liquid), editable
   in the theme editor. The values below are only fallbacks. */
(function(){
  var DEFAULTS = {
    band: true, popup: true, delay: 10, retry: true, retryDelay: 60,
    formUrl: 'https://cdb09963.sibforms.com/serve/MUIFAFWVIaloiQV2611DNvJy14ausZWlanli_D2ipvAAZd54MYpLLEKPXAIHWWCe4BDpLw3I-SPV4FY_CTCq_0ctufF-jSISvBCznDDhBmpGYb2rkVtLIK2BRNp7dKSP25G6d_Da2wNcVZdJsTirgCtVbw7fSYcJ7iT0HC-yGMeoSNUyq7MMRUd6Izn9nGidnjtDuQx4dhG5WRp98w==',
    eyebrow: 'Free mini course', bandHeading: '\u201cCuatro Vientos\u201d',
    bandText: 'One full song in small practice steps \u2014 tell us where to send it.',
    popupHeading: 'Get the free Cuatro Vientos course',
    popupText: 'Learn one full song start to finish \u2014 sent straight to your inbox.',
    placeholder: 'you@example.com', button: 'Send me the course',
    success: 'On its way! Check your inbox for the free course.',
    error: 'Something went wrong \u2014 please try again, or email info@shaiguitar.com.'
  };
  var DESIGN = !!(window.Shopify && Shopify.designMode);
  var SECTION_ID = 'free-course-signup';
  function readConfig(){
    var c = {};
    for(var d in DEFAULTS) c[d] = DEFAULTS[d];
    try {
      var el = document.getElementById('fc-config');
      if(el){
        var o = JSON.parse(el.textContent);
        for(var k in o){ if(o[k] !== null && o[k] !== undefined && o[k] !== '') c[k] = o[k]; }
      }
    } catch(_){}
    return c;
  }
  var cfg = readConfig();
  /* On the dedicated /pages/free-course page the section renders its own form: no band, no timed popup, but the submit handler below still runs. */
  var ONPAGE = !!document.querySelector('.fc-page');
  if(!cfg.band && !cfg.popup && !DESIGN && !ONPAGE){ return; }
  var BREVO_FORM_URL = cfg.formUrl;
  function esc(t){ return String(t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  var css =
    /* ---- shared form bits ---- */
    '.fc-form{display:flex;gap:10px;flex-wrap:wrap}' +
    '.fc-form input[type=email]{flex:1 1 220px;padding:13px 16px;border-radius:999px;border:1px solid rgba(243,237,228,.35);background:rgba(243,237,228,.1);color:#F3EDE4;font:inherit;font-size:15px;outline:none}' +
    '.fc-form input[type=email]::placeholder{color:rgba(243,237,228,.55)}' +
    '.fc-form input[type=email]:focus{border-color:#D38346;box-shadow:0 0 0 3px rgba(211,131,70,.25)}' +
    '.fc-form button{padding:13px 24px;border:0;border-radius:999px;cursor:pointer;font:inherit;font-size:15px;font-weight:700;color:#FFF;background:linear-gradient(120deg,#D38346 0%,#B25E28 70%);box-shadow:0 0 18px rgba(211,131,70,.35)}' +
    '.fc-note{font-size:13px;color:rgba(243,237,228,.6);margin-top:10px}' +
    '.fc-success{font-size:16.5px;font-weight:600;color:#F3EDE4;padding:10px 0}' +
    /* ---- footer band ---- */
    '.fc-band{position:relative;background:linear-gradient(100deg,#18231E 0%,#1D2019 46%,#2A1B10 100%);border-top:1px solid rgba(211,131,70,.28);overflow:hidden}' +
    '.fc-band::before{content:"";position:absolute;inset:0;background:radial-gradient(120% 220% at 82% 40%,rgba(211,131,70,.4) 0%,rgba(211,131,70,.14) 34%,rgba(0,0,0,0) 62%);pointer-events:none}' +
    '.fc-band-in{position:relative;z-index:1;max-width:1160px;margin:0 auto;padding:56px 24px;display:grid;grid-template-columns:1.1fr 1fr;gap:34px;align-items:center}' +
    '.fc-band h2{font-family:Marcellus,serif;font-weight:400;font-size:30px;line-height:1.15;color:#F3EDE4;margin:0 0 8px}' +
    '.fc-band p{color:rgba(243,237,228,.78);font-size:15.5px;margin:0;max-width:46ch}' +
    '.fc-eyebrow{font-size:12px;letter-spacing:.22em;text-transform:uppercase;font-weight:700;color:#D38346;margin:0 0 8px}' +
    '@media(max-width:760px){.fc-band-in{grid-template-columns:1fr;padding:40px 20px}.fc-form button{flex:1 1 100%;justify-content:center}}' +
    /* ---- modal ---- */
    '.fc-overlay{position:fixed;inset:0;z-index:200;background:rgba(20,14,10,.6);backdrop-filter:blur(4px);display:none;align-items:center;justify-content:center;padding:20px}' +
    '.fc-overlay.open{display:flex}' +
    '.fc-modal{position:relative;width:min(520px,100%);border-radius:22px;padding:38px 34px 32px;background:linear-gradient(100deg,#18231E 0%,#1D2019 46%,#2A1B10 100%);border:1px solid rgba(211,131,70,.35);box-shadow:0 30px 80px rgba(0,0,0,.45);overflow:hidden}' +
    '.fc-modal::before{content:"";position:absolute;inset:0;background:radial-gradient(140% 160% at 85% 20%,rgba(211,131,70,.4) 0%,rgba(211,131,70,.12) 40%,rgba(0,0,0,0) 65%);pointer-events:none}' +
    '.fc-modal>*{position:relative;z-index:1}' +
    '.fc-modal h2{font-family:Marcellus,serif;font-weight:400;font-size:26px;line-height:1.2;color:#F3EDE4;margin:0 0 10px}' +
    '.fc-modal p{color:rgba(243,237,228,.78);font-size:15px;margin:0 0 20px}' +
    '.fc-close{position:absolute;top:14px;right:16px;z-index:2;background:none;border:0;color:rgba(243,237,228,.7);font-size:26px;line-height:1;cursor:pointer;padding:6px}' +
    '.fc-close:hover{color:#FFF}' +
    '@media (prefers-reduced-motion:no-preference){.fc-overlay.open .fc-modal{animation:fc-in .22s ease}}' +
    '@keyframes fc-in{from{transform:translateY(14px);opacity:0}to{transform:none;opacity:1}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function formHTML(idPrefix){
    return '<form class="fc-form" method="post" action="' + BREVO_FORM_URL + '" accept-charset="UTF-8" novalidate>' +
      '<label class="fc-sr" for="' + idPrefix + '-email" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Email address</label>' +
      '<input id="' + idPrefix + '-email" type="email" name="EMAIL" required placeholder="' + esc(cfg.placeholder) + '" autocomplete="email">' +
      '<button type="submit">' + esc(cfg.button) + '</button>' +
      '</form>' +
      '<p class="fc-note" role="status"></p>';
  }

  function showSuccess(form){
    var wrap = form.parentNode;
    form.nextElementSibling && wrap.removeChild(form.nextElementSibling);
    wrap.removeChild(form);
    var ok = document.createElement('p');
    ok.className = 'fc-success';
    ok.setAttribute('role','status');
    ok.textContent = cfg.success;
    wrap.appendChild(ok);
  }

  var overlay = null;
  function build(){
    BREVO_FORM_URL = cfg.formUrl;
    var old = document.getElementById('free-course'); old && old.parentNode.removeChild(old);
    overlay && overlay.parentNode && overlay.parentNode.removeChild(overlay);

    /* ---- footer band ---- */
    var footer = document.querySelector('footer.site');
    if(footer && cfg.band && !ONPAGE){
      var band = document.createElement('section');
      band.className = 'fc-band';
      band.id = 'free-course';
      band.innerHTML = '<div class="fc-band-in"><div>' +
        (cfg.eyebrow ? '<p class="fc-eyebrow">' + esc(cfg.eyebrow) + '</p>' : '') +
        '<h2>' + esc(cfg.bandHeading) + '</h2>' +
        '<p>' + esc(cfg.bandText) + '</p>' +
        '</div><div>' + formHTML('fc-band') + '</div></div>';
      footer.parentNode.insertBefore(band, footer);
    }

    /* ---- modal ---- */
    overlay = document.createElement('div');
    overlay.className = 'fc-overlay';
    overlay.innerHTML = '<div class="fc-modal" role="dialog" aria-modal="true" aria-labelledby="fc-modal-title">' +
      '<button type="button" class="fc-close" aria-label="Close">&times;</button>' +
      '<h2 id="fc-modal-title">' + esc(cfg.popupHeading) + '</h2>' +
      '<p>' + esc(cfg.popupText) + '</p>' +
      formHTML('fc-modal') + '</div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function(e){
      if(e.target === overlay || e.target.closest('.fc-close')) closeModal();
    });
    overlay.addEventListener('fc:closed', onClosed);
  }

  var lastFocus = null, wasAuto = false;
  function openModal(auto){
    wasAuto = !!auto;
    lastFocus = document.activeElement;
    overlay.classList.add('open');
    var inp = overlay.querySelector('input[type=email]');
    inp && inp.focus();
  }
  function closeModal(){
    overlay.classList.remove('open');
    lastFocus && lastFocus.focus && lastFocus.focus();
    overlay.dispatchEvent(new Event('fc:closed'));
  }
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && overlay.classList.contains('open')) closeModal();
  });

  /* ---- timed popup ----
     "#free-course" links now scroll to the footer band like normal anchors.
     The modal opens itself instead: once after a short delay, and if closed,
     one more time 60s later. A submit ends it permanently (localStorage);
     two dismissals end it for the browsing session (sessionStorage). */
  var INITIAL_DELAY = Math.max(0, +cfg.delay || 0) * 1000, RETRY_DELAY = Math.max(15, +cfg.retryDelay || 60) * 1000;
  function lsGet(k){ try{ return localStorage.getItem(k); }catch(_){ return null; } }
  function lsSet(k){ try{ localStorage.setItem(k, '1'); }catch(_){} }
  function ssGet(k){ try{ return sessionStorage.getItem(k); }catch(_){ return null; } }
  function ssSet(k){ try{ sessionStorage.setItem(k, '1'); }catch(_){} }

  var autoDismissed = 0;
  function autoOpen(){
    if(lsGet('fc_done') || ssGet('fc_snoozed')) return;
    if(overlay.classList.contains('open')) return;
    /* don't interrupt someone already typing in the band form */
    if(document.activeElement && document.activeElement.closest && document.activeElement.closest('.fc-band')) return;
    openModal(true);
  }
  function onClosed(){
    if(!wasAuto || DESIGN) return; /* closing a manually opened modal doesn't count */
    autoDismissed++;
    if(autoDismissed === 1 && cfg.retry){ setTimeout(autoOpen, RETRY_DELAY); }
    else { ssSet('fc_snoozed'); }
  }
  build();

  /* "#free-course" links (e.g. the ladder card) open the popup directly;
     the footer band stays the no-JS fallback target */
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href="#free-course"]');
    if(!a || e.target.closest('.fc-band')) return;
    e.preventDefault();
    var m = document.querySelector('.nav-links.open');
    m && m.classList.remove('open');
    openModal();
  });
  if(cfg.popup && !DESIGN && !ONPAGE && !lsGet('fc_done') && !ssGet('fc_snoozed')){
    setTimeout(autoOpen, INITIAL_DELAY);
  }

  /* ---- theme editor ----
     In the editor the timed popup never fires on its own (it would get in the
     way while editing other sections). Instead: selecting the "Free course
     signup" section in the sidebar opens the popup so it can be previewed and
     edited, deselecting closes it, and saving a setting rebuilds the band and
     popup in place with the new copy — no reload, no incognito needed. */
  if(DESIGN){
    var mine = function(e){ return e.detail && e.detail.sectionId === SECTION_ID; };
    var selected = false;
    document.addEventListener('shopify:section:select', function(e){
      if(!mine(e)) return;
      selected = true; openModal(false);
    });
    document.addEventListener('shopify:section:deselect', function(e){
      if(!mine(e)) return;
      selected = false; closeModal();
    });
    document.addEventListener('shopify:section:load', function(e){
      if(!mine(e)) return;
      cfg = readConfig(); INITIAL_DELAY = Math.max(0, +cfg.delay || 0) * 1000; RETRY_DELAY = Math.max(15, +cfg.retryDelay || 60) * 1000;
      build();
      if(selected) openModal(false);
    });
  }

  /* submit in the background to Brevo — no page reload, no Shopify captcha.
     email_address_check is Brevo's honeypot: always sent empty. */
  document.addEventListener('submit', function(e){
    var f = e.target.closest('.fc-form');
    if(!f) return;
    e.preventDefault();
    var input = f.querySelector('input[type=email]');
    if(!input.value.trim() || !input.checkValidity()){ input.focus(); return; }

    var btn = f.querySelector('button[type=submit]');
    btn.disabled = true; btn.textContent = 'Sending…';

    var body = new URLSearchParams();
    body.set('EMAIL', input.value.trim());
    body.set('email_address_check', '');
    body.set('locale', 'en');

    function done(){
      lsSet('fc_done'); /* signed up — never auto-open the popup again */
      showSuccess(f);
    }
    function fail(){
      btn.disabled = false; btn.textContent = cfg.button;
      var note = f.nextElementSibling;
      if(note){ note.textContent = cfg.error; }
    }

    fetch(f.action, {
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: body.toString()
    }).then(function(r){
      (r.ok || r.type === 'opaque') ? done() : fail();
    }).catch(function(){
      /* CORS-restricted response: deliver fire-and-forget, then trust it */
      fetch(f.action, {method: 'POST', mode: 'no-cors', headers: {'Content-Type': 'application/x-www-form-urlencoded'}, body: body.toString()})
        .then(done).catch(fail);
    });
  });
})();
